import { Divider } from "@/components/shared/divider";
import { Card, CardContent, Skeleton, View } from "@/components/ui";

export function InvoiceCardSkeleton() {
  return (
    <Card>
      <CardContent className="flex flex-col">
        <View className="flex w-full flex-1 flex-row">
          <View className="flex-[2]">
            <View className="mb-2 flex flex-row items-center gap-2">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-5 w-16 rounded-full" />
            </View>
            <View className="flex flex-row gap-4">
              <View>
                <Skeleton className="mb-1 h-3 w-14" />
                <Skeleton className="h-4 w-24" />
              </View>
              <View>
                <Skeleton className="mb-1 h-3 w-12" />
                <Skeleton className="h-4 w-24" />
              </View>
            </View>
          </View>
          <Divider vertical />
          <View className="ml-4 flex flex-col gap-1 md:ml-12">
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-5 w-16" />
          </View>
        </View>
      </CardContent>
      <View className="flex w-full flex-1 flex-row gap-2 p-3 pb-4 md:ml-auto md:max-w-96">
        <Skeleton className="h-9 flex-1 rounded-md" />
        <Skeleton className="h-9 flex-1 rounded-md" />
      </View>
    </Card>
  );
}
